import React from 'react';
import { injectIntl } from 'react-intl';
import './Modal.css';

export interface IModal {
  intl: any;
  width?: number;
  height?: number;
  onClose: () => void;
  closeOnClickOutside?: boolean;
  autohide?: boolean;
}

const Modal: React.FunctionComponent<IModal> = props => {
  const width = props.width || 300;
  const height = props.height || 200;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const hide = props.autohide || false;
  if (hide) setTimeout(function(){props.onClose();}, 2000); // 2 second autohide
  return (
    <>
      <div className="ModalOverlay" onClick={() => props.closeOnClickOutside && props.onClose()}/>
      <div className="Modal"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          left: `${(screenWidth-width)/2}px`,
          top: `${(screenHeight-height)/2}px`
        }}
      >
        { props.children }
      </div>
    </>
  )
}

export default injectIntl(Modal);